import moment from 'moment';

import { mapValues } from 'lib/helpers/utility';

import {
  PATIENT_OPTIONS,
  PAYER_OPTIONS,
  PROVIDER_OPTIONS,
  SERVICE_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

const INCLUDE_TX_TYPE_OPTIONS = [
  { label: 'Credit Card', value: 'credit_card' },
  { label: 'Cash', value: 'cash' },
  { label: 'Check', value: 'check' },
  { label: 'Outside Financing', value: 'care_credit' },
  { label: 'Insurance Payments', value: 'era_eob' }
];

const EXCLUDE_OPTIONS = [
  { label: 'Unmatched Claims', value: 'unmatched_claims' },
  { label: 'Unallocated Payments', value: 'unallocated_payments' }
];

export const defaultFilters = {
  date: {
    title: 'Date',
    icon: 'calendar-mono',
    type: 'date-range',
    formula: 'is',
    values: {
      id: 'today',
      startDate: moment().format('MM/DD/YYYY'),
      endDate: moment().format('MM/DD/YYYY')
    },
    default: true
  },
  patient: { ...PATIENT_OPTIONS, allowed_operators: ['is', 'is not', 'is any of'] },
  provider: { ...PROVIDER_OPTIONS, allowed_operators: ['is', 'is not', 'is any of'] },
  payer: { ...PAYER_OPTIONS, allowed_operators: ['is', 'is not', 'is any of'] },
  service: { ...SERVICE_OPTIONS, allowed_operators: ['is', 'is not', 'is any of'] },
  include_tx_type: {
    title: 'Status',
    placeholder: 'Search by status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: INCLUDE_TX_TYPE_OPTIONS.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'billing_overview_include_tx_type.options',
    icon: 'status-mono',
    allowed_operators: ['is', 'is not', 'is any of']
  },
  exclude: {
    title: 'Exclude',
    placeholder: 'Search by exclude',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: EXCLUDE_OPTIONS.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'billing_overview_exclude.options',
    icon: 'minus-square-mono',
    allowed_operators: ['is']
  }
};

export const queryFilters = (filters) => {
  const mappedFilters = mapValues(filters);
  const result = {};

  Object.entries(mappedFilters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      result[key] = {
        formula: filters[key].formula || 'is any of',
        values: value.map((item) => item.value)
      };
      return;
    }

    if (typeof value === 'object') {
      result[key] = {
        formula: filters[key].formula || 'is any of',
        values: value
      };
      return;
    }

    result[key] = { formula: filters[key].formula || 'is any of', values: value };
  });

  return Object.entries(result).reduce((acc, [key, value]) => {
    if (value === null || value === undefined) {
      return acc;
    }
    return { ...acc, [key]: value };
  }, {});
};
